module.exports = __webpack_public_path__ + "static/media/图解机器学习.cdd0e2cc.png";